import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Create from "../views/quote/Create.vue";
import List from "../views/quote/List.vue";
import Corp from "../views/quote/Corp.vue";
import CotizadorManual from "../views/quote/CotizadorManual.vue";
import Perfil from "../views/Perfil.vue";
import ParametrosCotizador from "../views/ParametrosCotizador.vue";
import ContactList from "../views/crm/ContactList.vue";
import ContactDetail from "../views/crm/ContactDetail.vue";
import Pipeline from "../views/crm/Pipeline.vue";
import Inbox from "../views/crm/Inbox.vue";
import CrmSettings from "../views/crm/Settings.vue";
import Tasks from "../views/crm/Tasks.vue";
import CrmCompanies from "../views/crm/CrmCompanies.vue";
import CrmCompanyDetail from "../views/crm/CrmCompanyDetail.vue";
import Agenda from "../views/crm/Agenda.vue";
import Laboratorio from "../views/crm/Laboratorio.vue";
import Subscription from "../views/billing/Subscription.vue";
import PlatformCompanies from "../views/platform/Companies.vue";
import UserManagement from "../views/users/UserManagement.vue";
import Providers from "../views/operations/Providers.vue";
import Bookings from "../views/operations/Bookings.vue";
import Accounting from "../views/operations/Accounting.vue";
import InvoiceSettings from "../views/operations/InvoiceSettings.vue";
import { useAuth } from "@/composables/useAuth";

const routes = [
  {
    path: "/",
    redirect: "/signin", // 👈 ahora inicia en login
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }, // 👈 protegida
  },
  {
    path: "/quote",
    component: Tables,
    meta: { requiresAuth: true }, // 👈 protegida
    children: [
      {
        path: "create",
        name: "Generar Cotizacion",
        component: Create,
        meta: { requiresPermission: "ventas.nueva_cotizacion" },
      },
      {
        path: "corp",
        name: "Generar Cotizacion Corporativo",
        component: Corp,
        meta: { requiresPermission: "ventas.nueva_corporativa" },
      },
      {
        path: "manual",
        name: "Cotizacion Manual",
        component: CotizadorManual,
        meta: { requiresPermission: "ventas.nueva_manual" },
      },
      {
        path: "list",
        name: "ListCotizaciones",
        component: List,
        meta: { requiresPermission: "ventas.historial" },
      }
    ]
  },
  {
    path: "/crm",
    component: Tables,
    meta: { requiresAuth: true },
    children: [
      {
        path: "contacts",
        name: "Contactos",
        component: ContactList,
        meta: { requiresPermission: "contacts.view" },
      },
      {
        path: "contacts/:id",
        name: "Ficha de Contacto",
        component: ContactDetail,
        meta: { requiresPermission: "contacts.view" },
      },
      {
        path: "pipeline",
        name: "Embudo",
        component: Pipeline,
        meta: { requiresPermission: "pipeline.view" },
      },
      {
        path: "inbox",
        name: "Chats",
        component: Inbox,
        meta: { requiresPermission: "messaging.view" },
      },
      {
        path: "agenda",
        name: "Agenda",
        component: Agenda,
        meta: { requiresPermission: "agenda.view" },
      },
      {
        path: "tasks",
        name: "Tareas",
        component: Tasks,
        meta: { requiresPermission: "tasks.view" },
      },
      {
        path: "companies",
        name: "Empresas CRM",
        component: CrmCompanies,
        meta: { requiresPermission: "companies.view" },
      },
      {
        path: "companies/:id",
        name: "Ficha de Empresa",
        component: CrmCompanyDetail,
        meta: { requiresPermission: "companies.view" },
      },
      {
        path: "settings",
        name: "Conexiones CRM",
        component: CrmSettings,
        meta: { requiresAdmin: true },
      },
      {
        path: "lab",
        name: "Laboratorio IA",
        component: Laboratorio,
        meta: { requiresAdmin: true },
      },
    ]
  },
  {
    path: "/operations",
    component: Tables,
    meta: { requiresAuth: true },
    children: [
      {
        path: "providers",
        name: "Proveedores",
        component: Providers,
        meta: { requiresPermission: "providers.view" },
      },
      {
        path: "bookings",
        name: "Reservas",
        component: Bookings,
        meta: { requiresPermission: "bookings.view" },
      },
      {
        path: "accounting",
        name: "Contabilidad",
        component: Accounting,
        meta: { requiresAdmin: true, requiresPermission: "analitica.view" },
      },
      {
        path: "invoice-settings",
        name: "Facturación",
        component: InvoiceSettings,
        meta: { requiresAdmin: true },
      },
    ]
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true },
  },
  {
    path: "/billing/subscription",
    name: "Mi Plan y Facturacion",
    component: Subscription,
    meta: { requiresAuth: true },
  },
  {
    path: "/platform/companies",
    name: "Empresas",
    component: PlatformCompanies,
    meta: { requiresAuth: true, requiresPlatformAdmin: true }, // 👈 solo platform_admin
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requiresAuth: true },
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
    meta: { requiresAuth: true },
  },
  {
    path: "/parametros-cotizador",
    name: "Parametros Cotizador",
    component: ParametrosCotizador,
    meta: { requiresAuth: true, requiresAdmin: true }, // 👈 solo admin
  },
  {
    path: "/perfil",
    name: "Mi Perfil",
    component: Perfil,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "Gestión de Usuarios",
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// 🔐 GUARD GLOBAL
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("accessToken");

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next("/signin");
  }

  if ((to.path === "/signin" || to.path === "/") && isAuthenticated) {
    return next("/dashboard");
  }

  // 👑 Rutas solo para admin (algunas aceptan además un permiso puntual
  // concedido a un supervisor/asesor, ej. "analitica.view" para Contabilidad
  // -- ver meta.requiresPermission de la ruta).
  if (to.meta.requiresAdmin) {
    const { user, loadUser, hasPermission } = useAuth();
    await loadUser();

    const tienePermiso = to.meta.requiresPermission && hasPermission(to.meta.requiresPermission);

    if (user.value?.role !== "admin" && !tienePermiso) {
      return next("/dashboard");
    }
  }

  // 🏢 Rutas solo para el dueño de la plataforma (distinto de admin de empresa)
  if (to.meta.requiresPlatformAdmin) {
    const { user, loadUser } = useAuth();
    await loadUser();

    if (user.value?.role !== "platform_admin") {
      return next("/dashboard");
    }
  }

  // 🧭 Visibilidad de menú por submódulo (Ventas/CRM/Turismo/Operaciones):
  // no exige admin, exige el permiso puntual concedido desde Gestión de
  // Usuarios > Permisos (ver migración 026). Admin/platform_admin siempre
  // pasan, igual que el bypass del backend. Las rutas con requiresAdmin ya
  // resuelven su propio requiresPermission arriba (OR con el rol), así que
  // este bloque solo aplica a las que NO son admin-only.
  if (to.meta.requiresPermission && !to.meta.requiresAdmin) {
    const { user, loadUser, hasPermission } = useAuth();
    await loadUser();

    const esAdmin = user.value?.role === "admin" || user.value?.role === "platform_admin";

    if (!esAdmin && !hasPermission(to.meta.requiresPermission)) {
      return next("/dashboard");
    }
  }

  next();
});

export default router;